import {customAlphabet} from "nanoid/non-secure";

export const stableId = (len = 6) => {
    const nanoid = customAlphabet(
        "useandom26T198340PX75pxJACKVERYMINDBUSHWOLFGQZbfghjklqvwyzrict",
        len
    );
    return nanoid(len);
};
